import React from "react";
import { Link } from "react-router-dom";
import { LHSLogo } from "@/logos";
import { MessageCircle, Send, Mail, MapPin, ArrowLeft, Youtube, Facebook } from "lucide-react";

const CONTACTS = [
  { icon: MessageCircle, color: "emerald", title: "WhatsApp", value: "+243 853 483 113", href: "https://wa.me/243853483113" },
  { icon: Send,          color: "sky",     title: "Telegram", value: "+243 990 145 542", href: "https://t.me/+YVf1T1LTk-1iZGI8" },
  { icon: Mail,          color: "orange",  title: "Email officiel", value: "lhsunlocker@gmail.com", href: "mailto:lhsunlocker@gmail.com" },
  { icon: MessageCircle, color: "emerald", title: "Chaîne WhatsApp", value: "Annonces officielles", href: "https://whatsapp.com/channel/0029VbC6d2lGJP8MMhjeZK46" },
  { icon: Youtube,       color: "red",     title: "YouTube", value: "@LHSunlocker", href: "https://www.youtube.com/@LHSunlocker" },
  { icon: Facebook,      color: "blue",    title: "Facebook", value: "Page officielle", href: "https://www.facebook.com/profile.php?id=61594563128629" },
];

const COLOR_MAP = {
  emerald: "bg-emerald-500/10 border-emerald-500/30 text-emerald-400",
  sky:     "bg-sky-500/10 border-sky-500/30 text-sky-400",
  orange:  "bg-orange-500/10 border-orange-500/30 text-orange-400",
  red:     "bg-red-500/10 border-red-500/30 text-red-400",
  blue:    "bg-blue-500/10 border-blue-500/30 text-blue-400",
};

export default function ContactRevendeurPage() {
  return (
    <div className="p-4 sm:p-6 space-y-6" data-testid="contact-reseller-page">
      <Link to="/paiements" className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-orange-400">
        <ArrowLeft className="w-4 h-4" /> Retour aux formules
      </Link>

      <div className="card-lhs p-6 sm:p-8 text-center">
        <div className="flex justify-center mb-4"><LHSLogo size={72} /></div>
        <div className="text-xs uppercase tracking-widest text-orange-400 font-mono-tech mb-2">Support officiel</div>
        <h1 className="font-display text-2xl sm:text-3xl font-extrabold">Contacter l'administrateur</h1>
        <p className="text-zinc-400 text-sm sm:text-base mt-3 max-w-xl mx-auto">
          Pour acheter ou renouveler votre licence LHSunlocker, contactez-nous via l'un des canaux officiels ci-dessous.
          L'administrateur confirme votre paiement et active votre licence (généralement en moins de 30 minutes).
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
        {CONTACTS.map(c => (
          <a key={c.title} href={c.href} target="_blank" rel="noreferrer"
             data-testid={`contact-${c.title.toLowerCase().replace(/\s/g, "-")}`}
             className="card-lhs p-5 sm:p-6 hover:orange-glow transition flex items-start gap-4">
            <div className={`w-12 h-12 rounded-xl border flex items-center justify-center shrink-0 ${COLOR_MAP[c.color]}`}>
              <c.icon className="w-6 h-6" />
            </div>
            <div className="min-w-0">
              <div className="font-display font-extrabold">{c.title}</div>
              <div className="text-sm text-zinc-400 mt-1 font-mono-tech truncate">{c.value}</div>
              <div className={`text-[11px] font-mono-tech mt-2 ${COLOR_MAP[c.color].split(" ").find(x => x.startsWith("text-"))}`}>→ Ouvrir</div>
            </div>
          </a>
        ))}
      </div>

      <div className="card-lhs p-5 text-center text-sm text-zinc-400">
        <MapPin className="w-4 h-4 text-orange-500 inline mr-1" /> Goma, République démocratique du Congo · Support 24/7
      </div>
    </div>
  );
}
